module.exports = __webpack_public_path__ + "static/media/logistics-promo.e73fdbb3.jpg";